export const VIP_PAYMENT_QR_ENDPOINTS = {
  wechat: '/api/vip/payment-qr/wechat',
  alipay: '/api/vip/payment-qr/alipay',
}

export function vipPaymentQrEndpoint(channel) {
  return channel === 'alipay'
    ? VIP_PAYMENT_QR_ENDPOINTS.alipay
    : VIP_PAYMENT_QR_ENDPOINTS.wechat
}
